import collectionProcessDialog from './collectionProcessDialog';
import utils from 'utils';
class dataCollectionCtrl {
  constructor($scope, operationService, $uibModal, $filter, $rootScope) {
    // 上个月
    $scope.params = {
      postTime: utils.getLastMonthFirstLast().preMonth, // 时}
    };
    let activeSel = function () {
      if (operationService.hasPermit('sales_collection')) {
        return 1;
      }
      if (operationService.hasPermit('input_collection')) {
        return 2;
      }
      return -1;
    };
    $scope.active = activeSel();
    $scope.typeChange = function typeChange(v) {
      $scope.active = v;
    };
    // 流程说明弹出框
    $scope.messgaeTips = function () {
      return $uibModal.open({
        templateUrl: 'invoice-collection-process-dialog.html',
        controller: collectionProcessDialog,
        backdrop: 'static',
        openedClass: 'mod-modal mod-modal-lg',
        resolve: {
          items1() {},
        },
      }).result;
    };
    $scope.updateSearch = function () {
      let children = $scope.$$childTail.$$childTail.$$childTail;
      children.qrySelecInfo($scope.params.postTime);
      // $scope.$emit('dataCollectionSearch', $scope.params.postTime)
    };
  }
}

dataCollectionCtrl.$inject = [
  '$scope',
  'operationService',
  '$uibModal',
  '$filter',
  '$rootScope',
];
export default dataCollectionCtrl;



// WEBPACK FOOTER //
// ./src/app/declaration/vatDeclarationSurcharges/dataCollection/dataCollectionCtrl.js